import type { HTMLAttributes, ReactNode } from "react";
import "./Pill.css";

export type PillTone = "neutral" | "accent" | "ok" | "warn" | "danger" | "info";

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone;
  dot?: boolean;
  children: ReactNode;
}

export function Pill({ tone = "neutral", dot = false, className, children, ...rest }: PillProps) {
  return (
    <span className={["ui-pill", `ui-pill--${tone}`, className ?? ""].filter(Boolean).join(" ")} {...rest}>
      {dot && <span className="ui-pill__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}
